import SettingsPage from './SettingsPage.container'
export default SettingsPage
